import { FOUNDATION } from "../../constants"

export const MODAL_CONST = "MODAL"

export const CLOSE_MODAL = `${FOUNDATION}_CLOSE_MODAL`

export const OPEN_MODAL = `${FOUNDATION}_OPEN_MODAL`
